export default [
    { label: "Name", prop: "name", type: "text", group: "main", inputClass: "diagonal-wrap" },
    { label: "Description", prop: "description", type: "textarea", group: "main" },
]
